"use client";

import { usePathname } from "next/navigation";

import PaginationMenuContent from "@ui/js/components/pagination/shared-menu-content";

interface Props {
	page?: number;
	pages?: number;
}

export default function PaginationMenu({ page, pages }: Props) {
	const pathname = usePathname();
	const currentPage = page || 1;
	const basePath = (pathname && pathname.replace(/\/(\d+)$/, "")) || "";

	if (!pages || pages < 2) {
		return null;
	}

	return (
		<PaginationMenuContent
			currentPage={currentPage}
			pages={pages}
			getPageHref={(nextPage) => `${basePath}/${nextPage}`}
		/>
	);
}
